import * as React from 'react';
import { connect } from 'react-redux';
import { Button, CardLink, Col, Container, Fade, Row } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faTimes, faEdit, faChevronDown, faChevronUp, faInfo } from '@fortawesome/free-solid-svg-icons';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css'; 
import ReactPaginate from 'react-paginate';
import { DABDropDown, ConfirmModal, LoadingSpinnerModal } from '../../components/dab';
import { readingAction } from '../../actions/readingAction';
import { bibleAction } from '../../actions/bibleAction';
import { showAlert } from "../common/functions";
import { DABTextBox } from '../../components/dab';

interface IReadingPlanProps {
	dispatch: Dispatch<any>;
	readingData: any;
	bibleData: any;
	bibleIdFromQuery: any;
}

const ReadingList: React.SFC<IReadingPlanProps> = ({
	dispatch, readingData, bibleData, bibleIdFromQuery }) => {

	const history = useHistory();

	const initialValue = [{ text: "", value: 0, checked: false }];
	const initialInputValue = {
		bibleId: -1,
		languageCode: "",
		pageNumber: 1,
		pageSize: 25,
		sortColumn: "",
		sortDirection: "desc",
		searchString:""
	};

	const [isBibleLoaded, setIsBibleLoaded] = useState(false);
	const [isListLoaded, setIsListLoaded] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [selectedId, setSelectedId] = useState(0);
	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [localFilter, setLocalFilter] = useState(initialInputValue);
	const [pageList, setPageList] = useState([1]);
	const [bibleList, setBibleList] = useState(initialValue);
	const [languageList, setLanguageList] = useState(initialValue);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [isRestore, setIsRestore] = useState(false);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleCloseFilter = () => {
		handleToggle();
	}

	const handleClearFilter = () => {
		setFadeIn(false);
		readingData.isFilterAndTotalCountDataLoaded = false;
		setCurrentPageNo(0);
		setSearchText("");
		setFilterInput({
			...filterInput,
			bibleId: -1,
			languageCode: "",
			pageNumber: 1,
			searchString:""
		});
		setLocalFilter({
			...localFilter,
			bibleId: -1,
			languageCode: "",
			searchString:""
		});

		setShowClearFilter(false);
		handleGetByFilter();
	}

	const handleToggle = () => setFadeIn(!fadeIn);

	const handleGetByFilter = () => {
		setIsListLoaded(false);
		if (!showModal) {
			setShowModal(true);
		}
		var inp = filterInput
		if (bibleIdFromQuery >= 0) {
			inp.bibleId = bibleIdFromQuery;
		}
		dispatch(readingAction.readingGetByFilter(inp));
	}

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("Filter");
		if (filter != null && filter.trim() != "") {
			var filterObj = JSON.parse(filter.toString());
			if (filterObj != null) {
				setFilterInput(filterObj);
				setCurrentPageNo(filterObj.pageNumber - 1)
				setSearchText(filterObj.searchString)
				setIsRestore(true);
				sessionStorage.removeItem("fromPage");
			}
		}
	}

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		})
	};

	const handlePageNumberSet = (pageNo) => {
		setFilterInput({
			...filterInput,
			pageNumber: pageNo,
		});
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronDown} />
			}
		}
	}

	const handleLoadDeleteModal = (value: boolean) => {
		if (value)
		{
			dispatch(readingAction.readingDelete(selectedId));
			setShowModal(true);
		}
		setShowDeleteModal(false);
	};

	const handleSelectForDelete = (id: number) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	}

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div' onClick={(e) => { handleSort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	const handlePageClick = (data) => {
		handlePageNumberSet(data.selected + 1);
		setCurrentPageNo(data.selected);
	};


	if (isRestore && isListLoaded) {
		
		setIsRestore(false);
		setShowClearFilter(true);
	}

	React.useEffect(() => {
		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() === 'reading') {
			handleFilterRestore();
		}

		if (initialInputValue != filterInput) {
			sessionStorage.setItem("Filter", JSON.stringify(filterInput));
		} else {
			sessionStorage.removeItem("Filter");
		}
		handleGetByFilter();
	}, [filterInput]);

	if (!isListLoaded && !readingData.isLoading) {
		if (readingData.isListSuccess) {
			readingData.isListSuccess = false;
			setShowModal(false);
			setIsListLoaded(true);
			var total: number = readingData.totalCount;
			var pList: number[] = [];
			if (total > initialInputValue.pageSize) {
				for (var i = 1; i <= (total / initialInputValue.pageSize); i++) {
					pList.push(i);
				}
				if ((total % initialInputValue.pageSize) > 0) {
					pList.push((parseInt((total / initialInputValue.pageSize).toString()) + 1));
				}
			}
			else {
				pList.push(1);
			}
			setPageList(pList);
		}
	}

	if (readingData.isSuccess && readingData.isDeleteCompleted && !readingData.isError)
	{
		showAlert(readingData.status, false);
		readingData.isSuccess = false;
		readingData.isDeleteCompleted = false;
		handleGetByFilter();
		setSelectedId(-1);
	}

	
	if (!readingData.isSuccess && readingData.isError)
	{
		readingData.isError = false;
		if (readingData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(readingData.status, true);
		}
		setShowModal(false);
	}
	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;

		setLocalFilter({
			...localFilter,
			[name]: value,
		});
	};

	const handleSearch = () => {
		setShowClearFilter(true);
		setCurrentPageNo(0);
		setFilterInput({
			...filterInput,
			searchString: searchText,
			pageNumber: 1
		})
		setShowModal(true);
	}
	return (
		<div >
			<div className="reading-list" data-testid="readingListPage">
				<div className='card-box'>
					<Row className='filter-link-container'>
						<Col lg="3" className='column'>
							{showClearFilter ?
								<CardLink onClick={handleClearFilter} className='card-box-link-filter'>Clear Filter</CardLink>
								: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
						</Col>
						<Button id="submit" data-testid="createNewReading" className="btn-submit-frm" onClick={() => { window.location.href = '/reading?page=add' }}>Create New</Button>
					</Row>					
					<Row className="card-box">
						<Col lg="4" data-testid="searchContainer">
							<DABTextBox type="search" id="searchText" isRequired={false}
								onChange={(event) => { setSearchText(event.target.value) }}
								value={searchText} />
						</Col>
						<Col lg="3" data-testid="searchSubmitContainer">
							<Button id="submit" style={{ float: "left" }} color="primary" onClick={handleSearch} className="search-button">Search</Button>
						</Col>
					</Row>
				</div>
				<div className="reading-table">
					<table className="table table-hover text-center" data-testid="readingTable">
						<thead data-testid="readingTableHead">
							<tr>
								<th scope="col" data-testid="detail-th" >Details</th>
								<th scope="col" data-testid="language-th" >{handleGetSortColumn("Language", "Language")}</th>
								<th scope="col" data-testid="bible-th" >{handleGetSortColumn("Bible", "BIBLE")}</th>
								<th scope="col" data-testid="title-th" >{handleGetSortColumn("Readings", "TITLE")}</th>
								<th scope="col" data-testid="delete-th" >Delete</th>
							</tr>
						</thead>
						<tbody data-testid="readingTableBody" >
							{readingData && readingData.items.map((data: any) =>
									<tr key={data.readingId} >
									<th scope="row" data-testid={"detailReadingButton" + data.readingId}>
										<a href={`/reading?id=${data.readingId}`} className="detail-link" data-testid="readingDetailButton"
											onClick={() => sessionStorage.setItem("fromPage", "reading")}>
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faInfo} title="Details" />
										</a>
									</th>
									<td id="language">{data.languageTitle}</td>
									<td id="bible">{data.bibleTitle}</td>
									<td id="title">{data.title}</td>
									<td data-testid="deleteReadingButton">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faTrashAlt} data-bs-toggle="tooltip"
												data-bs-placement="bottom" title="Delete" onClick={() => { handleSelectForDelete(data.readingId); }} />
										</td>
									</tr>
							)}
							{readingData && readingData.items.length<=0&&
								<tr className="no-data">
									<th scope="row" colSpan={5}>
										<h4> No data found </h4>
									</th>
								</tr>
							}
						</tbody>
					</table>
				</div>
				<div className="pagination">
					<ReactPaginate
						previousLabel={'<<'}
						nextLabel={'>>'}
						breakLabel={'...'}
						pageCount={pageList.length}
						marginPagesDisplayed={2}
						pageRangeDisplayed={10}
						onPageChange={handlePageClick}
						forcePage={currentPageNo}
						containerClassName={'pagination'}
						pageClassName={"page-item"}
						previousClassName={"page-item"}
						breakClassName={"page-item"}
						breakLinkClassName={"page-link"}
						nextClassName={"page-item"}
						pageLinkClassName={"page-link"}
						previousLinkClassName={"page-link"}
						nextLinkClassName={"page-link"}
						activeClassName={'active'}
					/>
				</div>
				{
					showModal && (
						<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
					)
				}
				<ConfirmModal isShowModal={showDeleteModal} deleteMessage={"Are you sure, Do you want to remove this reading? "} modalChange={handleLoadDeleteModal} />
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { readingData, bibleData } = state;
	return {
		readingData, bibleData
	};
};

export default connect(mapStateToProps)(ReadingList);
